package org.example.project.engineservice.cr

import androidx.compose.runtime.*
import org.example.project.dashboard.DashboardTheme
import org.example.project.utils.All
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.example.project.service.ZustandManager
import org.example.project.settings.UISettings

private const val SYS_CR_DETAIL_MAX_WIDTH = 980

@Composable
internal fun SysCRBearbeitenLayout(
    crTickets: List<All>,
    crFilter: String,
    filteredCrTickets: List<All>,
    offeneTickets: Int,
    abgeschlosseneTickets: Int,
    selectedCr: All?,
    showPdfPreview: Boolean,
    selectedCrPdfUrl: String,
    editedAnforderung: String,
    editedAufwandStunden: String,
    editedAufwandFinal: String,
    editedKommentarIntern: String,
    editedCrInhalt: String,
    saving: Boolean,
    pdfPreviewContent: @Composable () -> Unit,
    onFilterChange: (String) -> Unit,
    onOpenCr: (All) -> Unit,
    onEditedAufwandStundenChange: (String) -> Unit,
    onEditedAufwandFinalChange: (String) -> Unit,
    onEditedKommentarInternChange: (String) -> Unit,
    onEditedCrInhaltChange: (String) -> Unit,
    onShowPdfPreviewChange: (Boolean) -> Unit,
    onOpenPreview: () -> Unit,
    onOpenChat: (All) -> Unit,
    workflowActionLabel: String,
    workflowActionEnabled: Boolean,
    onTriggerWorkflowAction: () -> Unit,
    onSendOffer: () -> Unit
) {
    if (selectedCr == null) {
        SysCRListLayout(
            crTickets = crTickets,
            crFilter = crFilter,
            filteredCrTickets = filteredCrTickets,
            offeneTickets = offeneTickets,
            abgeschlosseneTickets = abgeschlosseneTickets,
            onFilterChange = onFilterChange,
            onOpenCr = onOpenCr
        )
    } else {
        SysCRDetailLayout(
            selectedCr = selectedCr,
            editedAnforderung = editedAnforderung,
            editedAufwandStunden = editedAufwandStunden,
            editedAufwandFinal = editedAufwandFinal,
            editedKommentarIntern = editedKommentarIntern,
            editedCrInhalt = editedCrInhalt,
            saving = saving,
            onEditedAufwandStundenChange = onEditedAufwandStundenChange,
            onEditedAufwandFinalChange = onEditedAufwandFinalChange,
            onEditedKommentarInternChange = onEditedKommentarInternChange,
            onEditedCrInhaltChange = onEditedCrInhaltChange,
            onOpenPreview = onOpenPreview,
            onOpenChat = { onOpenChat(selectedCr) },
            workflowActionLabel = workflowActionLabel,
            workflowActionEnabled = workflowActionEnabled,
            onTriggerWorkflowAction = onTriggerWorkflowAction,
            onSendOffer = onSendOffer
        )
    }

    if (showPdfPreview && selectedCr != null) {
        Div({
            style {
                position(Position.Fixed)
                left(0.px)
                top(0.px)
                right(0.px)
                bottom(0.px)
                backgroundColor(Color("rgba(8,12,18,0.72)"))
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                justifyContent(JustifyContent.Center)
                padding(24.px)
                property("box-sizing", "border-box")
                property("z-index", "5000")
            }
            onClick { onShowPdfPreviewChange(false) }
        }) {
            Div({
                style {
                    position(Position.Relative)
                    width(100.percent)
                    maxWidth(920.px)
                    maxHeight(100.percent)
                    overflowY("auto")
                }
                onClick { it.stopPropagation() }
            }) {
                Div({
                    style {
                        display(DisplayStyle.Flex)
                        justifyContent(JustifyContent.FlexEnd)
                        paddingBottom(12.px)
                    }
                }) {
                    Button(attrs = {
                        style {
                            width(44.px)
                            height(44.px)
                            padding(0.px)
                            borderRadius(8.px)
                            backgroundColor(Color.transparent)
                            color(Color.white)
                            property("border", "1px solid rgba(255,255,255,0.34)")
                            cursor("pointer")
                            display(DisplayStyle.Flex)
                            alignItems(AlignItems.Center)
                            justifyContent(JustifyContent.Center)
                        }
                        onClick { onShowPdfPreviewChange(false) }
                    }) { Text("X") }
                }
            pdfPreviewContent()
        }
    }
}
}

@Composable
private fun SysCRListLayout(
    crTickets: List<All>,
    crFilter: String,
    filteredCrTickets: List<All>,
    offeneTickets: Int,
    abgeschlosseneTickets: Int,
    onFilterChange: (String) -> Unit,
    onOpenCr: (All) -> Unit
) {
    Div({
        style {
            marginTop(14.px)
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
            gap(18.px)
        }
    }) {
        @Composable
        fun counterItem(value: Int, filterKey: String, tint: String, numberColor: String) {
            Div({
                style {
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.Center)
                    gap(8.px)
                    cursor("pointer")
                    opacity(if (crFilter == filterKey) 1.0 else 0.72)
                }
                onClick { onFilterChange(filterKey) }
            }) {
                Img(src = "images/cr.svg") {
                    style {
                        width(32.px)
                        height(32.px)
                        property("filter", tint)
                    }
                }
                Span({
                    style {
                        fontSize(16.px)
                        fontWeight("700")
                        color(Color(numberColor))
                        property("color", numberColor)
                    }
                }) { Text(value.toString()) }
            }
        }

        Img(src = "images/filter_list_off.svg") {
            style {
                width(20.px)
                height(20.px)
                property("filter", "brightness(0) invert(1)")
            }
        }
        Span({ style { color(Color("#7e8795")); property("color", "#7e8795") } }) { Text("|") }
        counterItem(crTickets.size, "ALLE", "brightness(0) invert(1)", "#ffffff")
        Span({ style { color(Color("#7e8795")); property("color", "#7e8795") } }) { Text("|") }
        counterItem(offeneTickets, "OFFEN", "brightness(0) saturate(100%) invert(24%) sepia(92%) saturate(2920%) hue-rotate(344deg) brightness(98%) contrast(93%)", "#ff4d4f")
        Span({ style { color(Color("#7e8795")); property("color", "#7e8795") } }) { Text("|") }
        counterItem(abgeschlosseneTickets, "CLOSE", "brightness(0) saturate(100%) invert(65%) sepia(31%) saturate(690%) hue-rotate(78deg) brightness(94%) contrast(89%)", "#66BB6A")
    }

    Div({
        style {
            flexGrow(1)
            width(100.percent)
            marginTop(34.px)
            overflowY("auto")
            property("scrollbar-width", "none")
            property("-ms-overflow-style", "none")
        }
    }) {
        if (filteredCrTickets.isEmpty()) {
            Div({
                style {
                    flexGrow(1)
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.Center)
                    justifyContent(JustifyContent.Center)
                    textAlign("center")
                    width(100.percent)
                    minHeight(320.px)
                }
            }) {
                Span({ style { fontSize(18.px); fontWeight("600") } }) { Text("Keine CR-Tickets vorhanden.") }
            }
        } else {
            filteredCrTickets.forEachIndexed { index, ticket ->
                val statusTint = if (ZustandManager.CR.isFinal(ticket.zustand)) {
                    "brightness(0) saturate(100%) invert(65%) sepia(31%) saturate(690%) hue-rotate(78deg) brightness(94%) contrast(89%) drop-shadow(0 0 8px rgba(102,187,106,0.65))"
                } else {
                    "brightness(0) saturate(100%) invert(24%) sepia(92%) saturate(2920%) hue-rotate(344deg) brightness(98%) contrast(93%) drop-shadow(0 0 8px rgba(255,77,79,0.65))"
                }
                Div({
                    style {
                        marginBottom(10.px)
                        display(DisplayStyle.Flex)
                        flexDirection(FlexDirection.Row)
                        alignItems(AlignItems.Center)
                        justifyContent(JustifyContent.Center)
                        gap(14.px)
                        width(100.percent)
                        maxWidth(420.px)
                        property("margin-left", "auto")
                        property("margin-right", "auto")
                        property("box-sizing", "border-box")
                    }
                }) {
                    Span({
                        style {
                            fontSize(14.px)
                            fontWeight("700")
                            width(64.px)
                            minWidth(64.px)
                            textAlign("right")
                            alignSelf(AlignSelf.Center)
                            property("box-sizing", "border-box")
                        }
                    }) { Text("#${index + 1}") }
                    Div({
                        style {
                            padding(12.px, 14.px)
                            borderRadius(8.px)
                            property("background", UISettings.BLUE_SURFACE_GRADIENT)
                            property("border", "1px solid rgba(255,255,255,0.16)")
                            display(DisplayStyle.Flex)
                            flexDirection(FlexDirection.Row)
                            alignItems(AlignItems.Center)
                            gap(12.px)
                            width(100.percent)
                            maxWidth(310.px)
                            cursor("pointer")
                            property("box-sizing", "border-box")
                        }
                        onClick { onOpenCr(ticket) }
                    }) {
                        Div({
                            style {
                                width(52.px)
                                height(52.px)
                                position(Position.Relative)
                                flexShrink(0)
                            }
                        }) {
                            Img(src = "images/cr.svg") {
                                style {
                                    width(44.px)
                                    height(44.px)
                                    position(Position.Absolute)
                                    left(50.percent)
                                    top(50.percent)
                                    property("transform", "translate(-50%, -50%)")
                                    property("filter", statusTint)
                                }
                            }
                        }
                        Div({
                            style {
                                display(DisplayStyle.Flex)
                                flexDirection(FlexDirection.Column)
                                gap(4.px)
                                flexGrow(1)
                                alignItems(AlignItems.Center)
                                textAlign("center")
                            }
                        }) {
                            Span({ style { fontWeight("600") } }) { Text(ticket.crNummer.ifBlank { "CR-${ticket.id}" }) }
                            Span({ style { color(Color("#9aa4b5")); fontSize(12.px) } }) { Text("Kunde: ${ticket.kunde.ifBlank { "-" }}") }
                            Span({ style { color(Color("#9aa4b5")); fontSize(12.px) } }) { Text("Zustand: ${ZustandManager.CR.textFor(ticket.zustand)}") }
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun SysCRDetailLayout(
    selectedCr: All,
    editedAnforderung: String,
    editedAufwandStunden: String,
    editedAufwandFinal: String,
    editedKommentarIntern: String,
    editedCrInhalt: String,
    saving: Boolean,
    onEditedAufwandStundenChange: (String) -> Unit,
    onEditedAufwandFinalChange: (String) -> Unit,
    onEditedKommentarInternChange: (String) -> Unit,
    onEditedCrInhaltChange: (String) -> Unit,
    onOpenPreview: () -> Unit,
    onOpenChat: () -> Unit,
    workflowActionLabel: String,
    workflowActionEnabled: Boolean,
    onTriggerWorkflowAction: () -> Unit,
    onSendOffer: () -> Unit
) {
    val angebotKannGesendetWerden = editedCrInhalt.isNotBlank() && (editedAufwandStunden.trim().toIntOrNull() ?: 0) > 0
    val angebotIstFixiert = selectedCr.zustand >= ZustandManager.CR.VERBINDLICH
    val crFinalIstEditierbar = !angebotIstFixiert || selectedCr.zustand == ZustandManager.CR.IN_PROGRAMMIERUNG
    val workflowActionVisible = workflowActionLabel.isNotBlank() && !ZustandManager.CR.isFinal(selectedCr.zustand)
    var showAnforderung by remember(selectedCr.id) { mutableStateOf(false) }
    var showCrInhalt by remember(selectedCr.id) { mutableStateOf(false) }

    Div({
        style {
            flexGrow(1)
            width(100.percent)
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            gap(18.px)
            padding(24.px, 0.px, 24.px, 0.px)
            property("box-sizing", "border-box")
        }
    }) {
        Div({
            style {
                display(DisplayStyle.Flex)
                flexWrap(FlexWrap.Wrap)
                alignItems(AlignItems.Stretch)
                gap(12.px)
                width(100.percent)
                maxWidth(SYS_CR_DETAIL_MAX_WIDTH.px)
                alignSelf(AlignSelf.Center)
            }
        }) {
            SysCRField("Ticketnummer", selectedCr.crNummer.ifBlank { "CR-${selectedCr.id}" }, compact = true)
            SysCRField("Firma", selectedCr.firma.ifBlank { selectedCr.kunde.ifBlank { "-" } }, compact = true)
            SysCRField("FirmenId", selectedCr.firmenId.ifBlank { "-" }, compact = true)
            SysCRField("Zustand", ZustandManager.CR.textFor(selectedCr.zustand), compact = true)
            SysCRField("CR Art", if (selectedCr.crNeuesModul) "Neues Modul" else "Änderung", compact = true)
            SysCRField("Betreff", selectedCr.crBeschreibung.ifBlank { "-" }, compact = true)
        }

        Div({
            style {
                width(100.percent)
                maxWidth(SYS_CR_DETAIL_MAX_WIDTH.px)
                alignSelf(AlignSelf.Center)
                display(DisplayStyle.Flex)
                flexWrap(FlexWrap.Wrap)
                alignItems(AlignItems.Center)
                gap(16.px)
                padding(14.px, 18.px)
                borderRadius(12.px)
                backgroundColor(DashboardTheme.SURFACE_CARD)
                property("border", "1px solid rgba(255,255,255,0.10)")
                property("box-sizing", "border-box")
            }
        }) {
            SysCRInlineInputField("CR geschaetzt", editedAufwandStunden, "Stunden", !angebotIstFixiert) {
                onEditedAufwandStundenChange(it.replace(Regex("[^0-9]"), ""))
            }
            Div({ style { width(1.px); height(42.px); backgroundColor(Color("rgba(255,255,255,0.12)")) } }) {}
            SysCRInlineInputField("CR final", editedAufwandFinal, "Stunden", crFinalIstEditierbar) {
                onEditedAufwandFinalChange(it.replace(Regex("[^0-9]"), ""))
            }
        }

        Div({
            style {
                width(100.percent)
                maxWidth(SYS_CR_DETAIL_MAX_WIDTH.px)
                alignSelf(AlignSelf.Center)
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                gap(8.px)
            }
        }) {
            Div({
                style {
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.Center)
                    gap(10.px)
                    width(100.percent)
                }
            }) {
                Span({
                    style {
                        color(Color.white)
                        cursor("pointer")
                        fontSize(16.px)
                        width(18.px)
                        textAlign("center")
                        property("user-select", "none")
                    }
                    onClick { showAnforderung = !showAnforderung }
                }) {
                    Text(if (showAnforderung) "▾" else "▸")
                }
                Span({ style { color(DashboardTheme.TEXT_MUTED); fontSize(12.px); property("text-transform", "uppercase"); letterSpacing(0.6.px) } }) {
                    Text("Kundenanforderung")
                }
            }
            if (showAnforderung) {
                TextArea(attrs = {
                    value(editedAnforderung)
                    style {
                        width(100.percent)
                        minHeight(210.px)
                        padding(16.px)
                        borderRadius(12.px)
                        backgroundColor(DashboardTheme.SURFACE_CARD)
                        color(Color.white)
                        property("border", "1px solid rgba(255,255,255,0.10)")
                        property("box-sizing", "border-box")
                        property("resize", "vertical")
                        opacity(0.78)
                    }
                    disabled()
                })
            }
            Div({ style { width(100.percent); height(1.px); marginTop(6.px); marginBottom(6.px); backgroundColor(Color("rgba(255,255,255,0.18)")) } }) {}
            Span({ style { color(DashboardTheme.TEXT_MUTED); fontSize(12.px); property("text-transform", "uppercase"); letterSpacing(0.6.px) } }) { Text("") }
            Div({
                style {
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.Center)
                    gap(10.px)
                    width(100.percent)
                }
            }) {
                Span({
                    style {
                        color(Color.white)
                        cursor("pointer")
                        fontSize(16.px)
                        width(18.px)
                        textAlign("center")
                        property("user-select", "none")
                    }
                    onClick { showCrInhalt = !showCrInhalt }
                }) {
                    Text(if (showCrInhalt) "▾" else "▸")
                }
                Span({ style { color(DashboardTheme.TEXT_MUTED); fontSize(12.px); property("text-transform", "uppercase"); letterSpacing(0.6.px) } }) {
                    Text("CR Inhalt")
                }
            }
            if (showCrInhalt) {
                SysCRTextAreaField("CR Inhalt", editedCrInhalt, 220, !angebotIstFixiert, onEditedCrInhaltChange)
            }
        }

        Div({
            style {
                display(DisplayStyle.Flex)
                alignItems(AlignItems.FlexStart)
                flexWrap(FlexWrap.Wrap)
                justifyContent(JustifyContent.Center)
                gap(14.px)
                width(100.percent)
                maxWidth(SYS_CR_DETAIL_MAX_WIDTH.px)
                alignSelf(AlignSelf.Center)
            }
        }) {
            Button(attrs = {
                style {
                    width(44.px)
                    height(44.px)
                    padding(0.px)
                    borderRadius(8.px)
                    backgroundColor(Color.transparent)
                    color(Color.white)
                    property("border", "1px solid rgba(255,255,255,0.34)")
                    cursor("pointer")
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.Center)
                    justifyContent(JustifyContent.Center)
                    flexShrink(0)
                }
                onClick { onOpenPreview() }
            }) {
                Img(src = "images/view.svg") { style { width(20.px); height(20.px); property("filter", "brightness(0) invert(1)") } }
            }
            Button(attrs = {
                style {
                    width(44.px)
                    height(44.px)
                    padding(0.px)
                    borderRadius(8.px)
                    backgroundColor(Color.transparent)
                    color(Color.white)
                    property("border", "1px solid rgba(255,255,255,0.34)")
                    cursor("pointer")
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.Center)
                    justifyContent(JustifyContent.Center)
                    flexShrink(0)
                }
                onClick { onOpenChat() }
            }) {
                Img(src = "images/chat.svg") { style { width(20.px); height(20.px); property("filter", "brightness(0) invert(1)") } }
            }
            if (!angebotIstFixiert) {
                Button(attrs = {
                    style {
                        height(44.px)
                        padding(0.px, 18.px)
                        borderRadius(8.px)
                        backgroundColor(Color.transparent)
                        color(Color.white)
                        property("border", "1px solid rgba(255,255,255,0.34)")
                        property("white-space", "nowrap")
                        cursor("pointer")
                    }
                    if (saving || !angebotKannGesendetWerden) disabled()
                    onClick { if (angebotKannGesendetWerden) onSendOffer() }
                }) { Text(if (saving) "..." else "Angebot absenden") }
            } else if (workflowActionVisible) {
                Button(attrs = {
                    style {
                        height(44.px)
                        padding(0.px, 18.px)
                        borderRadius(8.px)
                        backgroundColor(Color.transparent)
                            color(Color.white)
                            property("border", "1px solid rgba(255,255,255,0.34)")
                            property("white-space", "nowrap")
                            opacity(if (workflowActionEnabled) 1.0 else 0.5)
                            cursor(if (workflowActionEnabled && !saving) "pointer" else "default")
                        }
                    if (saving || !workflowActionEnabled) disabled()
                    onClick { if (workflowActionEnabled) onTriggerWorkflowAction() }
                }) { Text(if (saving) "..." else workflowActionLabel) }
            }
        }
    }
}

@Composable
private fun SysCRLine(label: String, value: String, preWrap: Boolean = false, compact: Boolean = false) {
    Div({
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            gap(if (compact) 4.px else 6.px)
            if (compact) {
                property("width", "fit-content")
                property("flex", "0 1 220px")
                minWidth(160.px)
                maxWidth(320.px)
            } else width(100.percent)
            padding(if (compact) 10.px else 14.px)
            borderRadius(12.px)
            backgroundColor(DashboardTheme.SURFACE_CARD)
            property("border", "1px solid rgba(255,255,255,0.10)")
            property("box-sizing", "border-box")
            minWidth(0.px)
        }
    }) {
        Span({ style { color(DashboardTheme.TEXT_MUTED); fontSize(if (compact) 10.px else 12.px); property("text-transform", "uppercase"); letterSpacing(if (compact) 0.4.px else 0.6.px) } }) { Text(label) }
        Span({ style { fontWeight("600"); color(DashboardTheme.TEXT_LIGHT); fontSize(if (compact) 13.px else 15.px); property("overflow", "hidden"); property("text-overflow", "ellipsis"); property("white-space", if (preWrap) "pre-wrap" else "nowrap"); if (preWrap) property("white-space", "pre-wrap") } }) { Text(value) }
    }
}

@Composable
private fun SysCRField(label: String, value: String, preWrap: Boolean = false, compact: Boolean = false) {
    SysCRLine(label, value, preWrap, compact)
}

@Composable
private fun SysCRInlineInputField(label: String, value: String, placeholder: String, enabled: Boolean, onValueChange: (String) -> Unit) {
    Div({
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            justifyContent(JustifyContent.Center)
            gap(4.px)
            property("flex", "1 1 240px")
            minWidth(220.px)
            property("box-sizing", "border-box")
        }
    }) {
        Span({ style { color(DashboardTheme.TEXT_MUTED); fontSize(10.px); property("text-transform", "uppercase"); letterSpacing(0.4.px) } }) { Text(label) }
        Input(InputType.Number, attrs = {
            value(value)
            style {
                width(100.percent)
                height(32.px)
                padding(0.px)
                borderRadius(0.px)
                backgroundColor(Color.transparent)
                color(Color.white)
                fontSize(18.px)
                fontWeight("600")
                property("border", "none")
                property("outline", "none")
                property("box-shadow", "none")
                property("box-sizing", "border-box")
                opacity(if (enabled) 1.0 else 0.72)
            }
            if (!enabled) disabled()
            onInput { onValueChange(it.value.toString()) }
            attr("placeholder", placeholder)
        })
    }
}

@Composable
private fun SysCRTextAreaField(label: String, value: String, minHeightPx: Int, enabled: Boolean, onValueChange: (String) -> Unit) {
    Div({
        style {
            width(100.percent)
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            gap(8.px)
        }
    }) {
        Span({ style { color(DashboardTheme.TEXT_MUTED); fontSize(12.px); property("text-transform", "uppercase"); letterSpacing(0.6.px) } }) { Text(label) }
        TextArea(attrs = {
            value(value)
            style {
                width(100.percent)
                minHeight(minHeightPx.px)
                padding(16.px)
                borderRadius(12.px)
                backgroundColor(DashboardTheme.SURFACE_CARD)
                color(Color.white)
                property("border", "1px solid rgba(255,255,255,0.10)")
                property("box-sizing", "border-box")
                property("resize", "vertical")
                opacity(if (enabled) 1.0 else 0.72)
            }
            if (!enabled) disabled()
            onInput { onValueChange(it.value) }
        })
    }
}
